import Cookies from 'js-cookie'
import { MIN_INDEX, DEVICE_TYPES } from '~/configs/constants'
import commonStyling from '!!raw-loader!~/assets/scss/common.css'

export function mediaBreakpointDown(size) {
    //relative to bootstrap breakpoints
    let matches = false
    switch (size) {
        case 'xs': {
            matches = window.matchMedia('(max-width: 575.98px)').matches
            break
        }
        case 'sm': {
            matches = window.matchMedia('(max-width: 767.98px)').matches
            break
        }
        case 'md': {
            matches = window.matchMedia('(max-width: 991.98px)').matches
            break
        }
        case 'lg': {
            matches = window.matchMedia('(max-width: 1199.98px)').matches
            break
        }
        case 'xl': {
            matches = window.matchMedia('(max-width: 1399.98px)').matches
            break
        }
        default:
            break
    }
    return matches
}

export function sleep(ms) {
    return new Promise((resolve) => setTimeout(() => resolve(true), ms))
}

export function isInIframe() {
    try {
        return window.self !== window.top
    } catch (e) {
        return true
    }
}

export function isWixSite(customDocument = document) {
    // Check for meta generator tag
    const metaGenerator = customDocument.querySelector('meta[name="generator"]')
    if (metaGenerator) {
        const content = metaGenerator.getAttribute('content')
        if (content && content.toLowerCase().includes('wix')) {
            return true
        }
    }

    // Check for Wix-specific scripts or resources
    const scripts = Array.from(customDocument.getElementsByTagName('script'))
    for (let script of scripts) {
        if (script.src.includes('wixstatic.com') || script.src.includes('parastorage.com')) {
            return true
        }
    }

    // Check for Wix-specific classes or IDs
    const wixClasses = customDocument.querySelectorAll('[class*="wix-"], [id*="SITE_CONTAINER"]')
    if (wixClasses.length > 0) {
        return true
    }

    return false
}

export function redirectOriginFullscreen(props) {
    const url = new URL(document.referrer)
    for (let prop in props) {
        url.searchParams.set(prop, props[prop])
    }
    window.open(url.toString(), '_blank')
}

export function redirectShortVideoOrigin(props) {
    const url = new URL(process.env.SHORT_VIDEO_ORIGIN)
    for (let prop in props) {
        url.searchParams.set(prop, props[prop])
    }
    window.open(url.toString(), '_blank')
}

export function pad(num, shortFormat = false) {
    if (shortFormat) {
        return `${num}`.slice(-2)
    }
    return ('0' + num).slice(-2)
}
export function formatVideoTime(secs, shortFormat = false) {
    if (secs < 0) {
        return `${this.pad(0, shortFormat)}:${this.pad(0)}`
    }
    let minutes = Math.floor(secs / 60)
    secs = secs % 60
    const hours = this.pad(Math.floor(minutes / 60))
    minutes = minutes % 60
    if (hours === '00') return `${this.pad(minutes, shortFormat)}:${this.pad(secs)}`
    return `${hours}:${this.pad(minutes, shortFormat)}:${this.pad(secs)}`
}
export function detectClickOutside() {
    return {
        bind: (el, callback) => {
            el.clickOutsideEvent = (event) => {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    if (callback) callback(event)
                }
            }
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: (el) => {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    }
}
export function debounce(func, wait, immediate) {
    let timeout
    return function () {
        let context = this,
            args = arguments
        let later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        let callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}
export function selectAllVideosInShadowDOM(element, group, callback) {
    // Check if the element has a shadow root
    if (element.shadowRoot !== null) {
        // Select all the video elements inside the shadow root
        let videoElements = []
        if (group) {
            videoElements = element.shadowRoot.querySelectorAll(`video[group="${group}"]`)
        } else {
            videoElements = element.shadowRoot.querySelectorAll(`video`)
        }
        // Call the callback function with each video element
        videoElements.forEach((videoElement) => {
            callback(videoElement)
        })
        // Recursively traverse the shadow DOM of the element
        const shadowChildren = element.shadowRoot.children
        for (let i = 0; i < shadowChildren.length; i++) {
            this.selectAllVideosInShadowDOM(shadowChildren[i], group, callback)
        }
    }
    // Recursively traverse the children of the element
    const children = element.children
    for (let i = 0; i < children.length; i++) {
        this.selectAllVideosInShadowDOM(children[i], group, callback)
    }
}
export function selectAllElementsInShadowDOMByQuery(parentElement, querySearch, callback) {
    // Check if the element has a shadow root
    if (parentElement.shadowRoot !== null) {
        // Select all the video elements inside the shadow root
        let elements = []
        elements = parentElement.shadowRoot.querySelectorAll(querySearch)
        // Call the callback function with each video element
        elements.forEach((element) => {
            callback(element)
        })
        // Recursively traverse the shadow DOM of the element
        const shadowChildren = parentElement.shadowRoot.children
        for (let i = 0; i < shadowChildren.length; i++) {
            this.selectAllElementsInShadowDOMByQuery(shadowChildren[i], querySearch, callback)
        }
    }
    // Recursively traverse the children of the element
    const children = parentElement.children
    for (let i = 0; i < children.length; i++) {
        this.selectAllElementsInShadowDOMByQuery(children[i], querySearch, callback)
    }
}

export function detectDevice() {
    const userAgent = navigator.userAgent.toLowerCase()

    // Check for mobile devices
    const isMobile = /mobile|blackberry|iemobile|opera mini|phone/i.test(userAgent)

    // Check for tablets
    const isTablet = !isMobile && /tablet/i.test(userAgent)

    // Check for iOS devices
    const isIOS = /iphone|ipod/i.test(userAgent)
    const isIPad = !isIOS && /ipad/i.test(userAgent)

    // Check for Android devices
    const isAndroid = /android/i.test(userAgent)

    if (isIPad) {
        return DEVICE_TYPES.IOS_TABLET
    } else if (isIOS) {
        return DEVICE_TYPES.IOS_MOBILE
    } else if (isAndroid) {
        if (isMobile) {
            return DEVICE_TYPES.ANDROID_MOBILE
        } else {
            return DEVICE_TYPES.ANDROID_TABLET
        }
    } else {
        if (isTablet) {
            return DEVICE_TYPES.UNKNOWN_TABLET
        } else if (isMobile) {
            return DEVICE_TYPES.UNKNOWN_MOBILE
        } else {
            return DEVICE_TYPES.DESKTOP
        }
    }
}

export async function getCountryCode() {
    const countryCodeExpression = /loc=([\w]{2})/
    const locale = Cookies.get('lr-locale')
    if (typeof locale === 'string' && locale !== 'null') return locale
    //automatic country determination.
    let countryCode
    try {
        let data = await fetch('https://1.1.1.1/cdn-cgi/trace').then((res) => res.text())

        countryCode = countryCodeExpression.exec(data)
        if (countryCode !== null && countryCode[1]) {
            Cookies.set('lr-locale', countryCode[1])
            return countryCode[1]
        }
    } catch (error) {
        console.error(error)
    }
}

export function isFetchMoreData(totalItems, nextIndex) {
    return totalItems - MIN_INDEX === nextIndex
}

export function initialObserver(childs, cb, override = {}) {
    if (!childs) return
    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
        ...override,
    }

    let observer = new IntersectionObserver(cb, options)
    observer.observe(childs)
}

export function stopPropagationTouchEvent(el) {
    if (!el) return
    const touchEvents = ['touchstart', 'touchend', 'touchmove']
    touchEvents.forEach((e) => {
        el.addEventListener(e, (event) => {
            event.stopPropagation()
        })
    })
}

export function appendCommonStyling(el) {
    if (!el) return
    const style = document.createElement('style')
    style.innerHTML = commonStyling
    el.appendChild(style)
}

export function formatNumberToString(number) {
    let newValue = number
    if (number >= 1000) {
        const suffixes = ['', 'k', 'm', 'b', 't']
        const suffixNum = Math.floor(('' + number).length / 3)
        let shortValue = ''
        for (let precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat(
                (suffixNum != 0 ? number / Math.pow(1000, suffixNum) : number).toPrecision(precision)
            )
            const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')
            if (dotLessShortValue.length <= 2) {
                break
            }
        }
        if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1)
        newValue = shortValue + suffixes[suffixNum]
    }
    return newValue
}
